var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BankAccountForm',{staticClass:"mb",attrs:{"bank-accounts":_vm.user.bankAccounts},on:{"validate-field":_vm.validateField}}),_c('br'),_c('FinancialDataForm',{attrs:{"investment-profile":_vm.user.investmentProfile},on:{"validate-field":_vm.validateField}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }